import { IRouteState } from './../../../../../app.common/modules/routes/models';
import * as angular from 'angular';
import { InventoryService } from '../../inventory.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateService } from '@uirouter/core';
import { Open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements as categoryWithItemTypesAndMeasurements } from '../../../model/open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements';
import { AccountService } from '../../../account/account.service';
import { MenuPreference } from '../../../core/index';
import { FoodPreferenceService } from '../../../foodPreferences/foodPreference.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';

class HelpPreferencesController implements ng.IComponentController {
    static $inject = ['popupService', 'foodPreferenceService', 'notificationService', '$state', '$translate', '$location'];

    waiting: boolean;
    foodPreferences: MenuPreference[];
    allergens: MenuPreference[];
    isNotPublicRoute: boolean;
    foodPreferenceDescription: string;
    allergensDescription: string;

    constructor(
        private readonly  popupService: PopupService,
        private readonly foodPreferencesService: FoodPreferenceService,
        private readonly notificationServcie: NotificationService,
        private readonly $state: StateService,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly $location: ng.ILocationService,
    ) {
    }

    goToProductsImport() {
        this.$state.go('app.operations');
    }

    goToHelp() {
        this.$state.go('app.help.manual');
    }

    ShowTooltip (title: string, message: string) {
        this.popupService.alert({
           title: title,
           okTxt: this.$translate.instant('close'),
           okClass: 'btn-success',
           content: message,
           classPopup: 'preferencePopup'
       });
   }


    async $onInit() {
        this.isNotPublicRoute = this.$location.path() !== '/help/dictionary';
        this.waiting = true;

        try {
            this.allergens = await this.foodPreferencesService.getAllergens();
            this.allergensDescription = this.bindDescription(this.allergens);
            this.foodPreferences = await this.foodPreferencesService.getFoodPreference();
            this.foodPreferenceDescription = this.bindDescription(this.foodPreferences);
        } catch (e) {
            this.notificationServcie.showErrorMessage(e);
        }

        this.waiting = false;
    }
    private bindDescription(preference: MenuPreference[]) : string {
        let result = '';
        result += '<table class="preferenceDescription">';
        let counter = 0;
        preference.sort((a, b) => (a.Description.length > b.Description.length) ? -1 : ((b.Description.length > a.Description.length) ? 1 : 0))
                  .forEach( (c) => {
                        if (counter % 3 === 0) {
                            result += '<tr>';
                        }

                        result += '<td><h3>' + c.Name + '</h3>' + c.Description + '</br></td>';
                        counter++;

                        if (counter % 3 === 0) {
                            result += '</tr>';
                        }
        });
        result += '</table>';
        return result;
    }
}

angular
    .module('naut')
    .component('helpPreferences', {
        controller: HelpPreferencesController,
        template: require('./help-preferences.component.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/help-preferences/help-preferences.component.ts